module.exports = __webpack_public_path__ + "img/aijiuxuewei.897ca85e.png";